/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
import { TabBarContainer_story$ref } from "./TabBarContainer_story.graphql";
import { TabBarContainer_viewer$ref } from "./TabBarContainer_viewer.graphql";
export type TabBarQueryVariables = {
    readonly storyID?: string | null;
    readonly storyURL?: string | null;
};
export type TabBarQueryResponse = {
    readonly viewer: {
        readonly " $fragmentRefs": TabBarContainer_viewer$ref;
    } | null;
    readonly story: {
        readonly " $fragmentRefs": TabBarContainer_story$ref;
    } | null;
};
export type TabBarQuery = {
    readonly response: TabBarQueryResponse;
    readonly variables: TabBarQueryVariables;
};



/*
query TabBarQuery(
  $storyID: ID
  $storyURL: String
) {
  viewer {
    ...TabBarContainer_viewer
    id
  }
  story(id: $storyID, url: $storyURL) {
    ...TabBarContainer_story
    id
  }
}

fragment TabBarContainer_viewer on User {
  role
}

fragment TabBarContainer_story on Story {
  settings {
    mode
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "storyID",
            "type": "ID",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "storyURL",
            "type": "String",
            "defaultValue": null
        } as any)
    ], v1 = [
        ({
            "kind": "Variable",
            "name": "id",
            "variableName": "storyID"
        } as any),
        ({
            "kind": "Variable",
            "name": "url",
            "variableName": "storyURL"
        } as any)
    ], v2 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "TabBarQuery",
            "type": "Query",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "User",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "TabBarContainer_viewer",
                            "args": null
                        }
                    ]
                },
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "story",
                    "storageKey": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "Story",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "TabBarContainer_story",
                            "args": null
                        }
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "TabBarQuery",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "User",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "role",
                            "args": null,
                            "storageKey": null
                        },
                        (v2 /*: any*/)
                    ]
                },
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "story",
                    "storageKey": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "Story",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "settings",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "StorySettings",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "mode",
                                    "args": null,
                                    "storageKey": null
                                }
                            ]
                        },
                        (v2 /*: any*/)
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "query",
            "name": "TabBarQuery",
            "id": "4b0571c821cd974570f45467a1c6ede4",
            "text": null,
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = 'a515cc981987cb69e9357526b3d7406d';
export default node;
